import { atom } from "recoil";

export const noticeDetailState = atom({
  key: "noticeDetailState",
  default: {},
});
